import * as PropTypes from 'prop-types';
import * as React from 'react';
import CSRFForm from '../shared/csrf_form';
import BankAccountFields from '../shop/direct_checkout_profile/bank_account_fields';

const bankAccountFieldsPropsWithDefaults = props =>
  Object.assign(
    {},
    props,
    {
      onCountryChange: () => null,
      onCurrencyChange: () => null,
      dashboardView: false,
    },
  );

const BankAccountForm = props =>
  (<CSRFForm
    method="PUT"
    action={props.saveBankAccountUrl}
  >
    <BankAccountFields {...bankAccountFieldsPropsWithDefaults(props.bankAccountFieldsProps)} />
    <button
      className="btn btn-primary scaling-mt-1"
      type="submit"
    >
      {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.save')}
    </button>
   </CSRFForm>);

BankAccountForm.propTypes = {
  saveBankAccountUrl: PropTypes.string.isRequired,
  bankAccountFieldsProps: PropTypes.shape({
    fieldsNamePrefix: PropTypes.string.isRequired,
    bankLookupUrl: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    countryCodeOptions: PropTypes.array.isRequired,
    currencies: PropTypes.object,
    selectedPayoutCurrency: PropTypes.string.isRequired,
    shopCurrency: PropTypes.string.isRequired,
  }),
};

export default BankAccountForm;



// WEBPACK FOOTER //
// ./javascripts/components/bank_transfer_requests/bank_account_form.jsx